import { axiosV1 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type RangeInput = {
  from: number;
  to: number;
};

type CheckClassRangeOverlapsProps = {
  holdingClassId?: string;
  ranges: RangeInput[];
  excludeKeys?: RangeInput[];
};

export const checkClassRangeOverlaps =
  ({ holdingClassId, ranges, excludeKeys }: CheckClassRangeOverlapsProps) =>
  async (dispatch: any) => {
    const body = { holdingClassId, ranges, excludeKeys };

    try {
      const { data } = await axiosV1.post(
        '/holdingClasses/check-range-overlaps',
        body
      );

      const decodedData: any = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
